'use strict';

var React = require('react');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);

function SvgRefreshCircle(props) {
    return (React__default.default.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", ...props },
        React__default.default.createElement("defs", null,
            React__default.default.createElement("path", { d: "M6 0a6 6 0 110 12A6 6 0 016 0zm-.356 2.589c-1.573.158-2.867 1.435-3.043 3.008A3.422 3.422 0 009.09 7.474a.43.43 0 00-.763-.39 2.569 2.569 0 01-2.914 1.419 2.549 2.549 0 01-1.92-1.937A2.572 2.572 0 016 3.429c.711 0 1.346.295 1.809.762l-.648.648a.429.429 0 00.3.732H9a.43.43 0 00.429-.428V3.604a.43.43 0 00-.733-.304l-.275.279a3.407 3.407 0 00-2.777-.99z", id: "Refresh-circle_svg__a" })),
        React__default.default.createElement("g", { fill: "none", fillRule: "evenodd" },
            React__default.default.createElement("path", { d: "M0 0h16v16H0z" }),
            React__default.default.createElement("g", { transform: "translate(2 2)" },
                React__default.default.createElement("path", { d: "M0 0h12v12H0z" }),
                React__default.default.createElement("use", { fill: "currentColor", xlinkHref: "#Refresh-circle_svg__a" })))));
}

module.exports = SvgRefreshCircle;
//# sourceMappingURL=RefreshCircle.js.map
